import {LitElement, html} from "lit";
import {mix} from "mixwith";
import StateMixin from "../Mixins/StateMixin.js";
import MutableValueMixin from "../Mixins/MutableValueMixin.js";
import {nothing} from "lit";
import {directive, Directive} from "lit/directive.js";
import {ifDefined} from "lit/directives/if-defined.js";
import {classMap} from "lit/directives/class-map.js";
import AuiInputStyle from "./aui-input-style.scss";

class FormatNativeInputValue extends Directive {

	render(value) {
		if(value === null || value === undefined) {
			return "";
		} else
			return value;
	}

}

export const formatNativeInputValue = directive(FormatNativeInputValue);

export function validateEmail(value) {
}

export class AuiInput extends mix(LitElement).with(StateMixin, MutableValueMixin) {

	static get properties() {
		return {
			useLightDOM: { type: Boolean, attribute: "use-light-dom", reflect: true },

			type: { type: String, reflect: true },
			label: { type: String, reflect: true },
			infoText: { type: String, attribute: "info-text", reflect: true },
			placeholder: { type: String, reflect: true },
			maxlength: { type: Number, reflect: true },
			isRequired: { type: Boolean, attribute: "required", reflect: true },
			isReadonly: { type: Boolean, attribute: "readonly", reflect: true },

			// type="number" only
			min: String,
			max: String,
			step: String,

			// TODO:
			validate: { type: Function, attribute: false },
			isInvalid: { type: Boolean, attribute: false },
			errorMessage: { type: String, attribute: false },
		};
	}

	set value(value) {
		const oldValue = this.__value;
		this.__value = this.type === "number" ? Number(value) : value;
		this.requestUpdate("value", oldValue);
	}

	get value() {
		return this.__value;
	}

	set type(value) {
		const oldValue = this.__type;
		this.__type = value;
		this.requestUpdate("type", oldValue);
	}

	get type() {
		return this.__type;
	}

	get Input() {
		if(!this._input)
			this._input = (this.useLightDOM ? this : this.shadowRoot).querySelector("input");
		return this._input;
	}

	constructor() {
		super();
		this.useLightDOM = false;
	}

	firstUpdatedBeforeRender() {
		super.firstUpdatedBeforeRender();
		this.setAttribute("tabindex", 0);

		if(!this.value && this.defaultValue)
			this.value = this.defaultValue;
	}

	update(changedProperties) {
		super.update(changedProperties);

		if(this.useLightDOM) {
			const inputTemplate = this.renderNativeInput();
			this.constructor.render(inputTemplate, this, { scopeName: this.localName, eventContext: this });
		}
	}

	reset() {
		super.reset();
		this.value = this.defaultValue;
	}

	validate() {
		return true;
	}

	_onInputChange(e) {
		e.stopPropagation();
		this.value = e.target.value;
	}

	_focusBlurHandler(e) {
		super._focusBlurHandler(e);

		// Retarget focus to input
		if(e.type === "focus")
			this.Input.focus();
	}

	static get styles() {
		return AuiInputStyle;
	}

	/**
	 * Returns a classMap for the input.
	 *
	 * @return {ClassInfo}
	 */
	getInputClassMap() {
		return {};
	}

	render() {
		return html`
			${this.renderLabel(this.label)}
			${this.renderInputContainer()}
			${this.isInvalid ? this.renderError("This is an error!") : nothing}
			${this.renderInfoText(this.infoText)}
		`;
	}

	renderLabel(label) {
		return html`<span class="label">${label}</span>`;
	}

	renderInputContainer() {
		return html`
			<div class="inputContainer">
				${this.renderBeforeInput()}
				${this.useLightDOM ? html`<slot></slot>` : this.renderNativeInput()}
				${this.renderAfterInput()}
			</div>
		`;
	}

	renderBeforeInput() { return nothing; }
	renderAfterInput() { return nothing; }

	renderNativeInput() {
		return html`<input
			class=${classMap(this.getInputClassMap())}
			type=${ifDefined(this.type)}
			placeholder=${ifDefined(this.placeholder)}
			maxlength=${ifDefined(this.maxlength)}
			readonly=${ifDefined(this.isReadonly)}
			.value=${formatNativeInputValue(this.value)}
			@input=${this._onInputChange}

			min=${ifDefined(this.min)}
			max=${ifDefined(this.max)}
			step=${ifDefined(this.step)}
		>`;
	}

	renderError(message) {
		return html`<span class="error">${message}</span>`;
	}

	renderInfoText(text) {
		return html`<span class="infoText">${text}</span>`;
	}

}

export default AuiInput;

customElements.define("aui-input", AuiInput);